import React from 'react';
import TitleAlt from './../../atoms/TitleAlt.jsx'
import PropTypes from 'prop-types';

const CardLastProjects = ({LinkProject, LinkImage, Title, Description}) => (
    <article className="last-project-card">
        
        <p style={{margin : '0px'}} className="container-image-last-project">
            <a target="_blank" rel="noreferrer" href={ LinkProject }>
                        <img src={ LinkImage } alt={TitleAlt} />
            </a>
        </p>

        <section className="section-description-for-project">
            <h2> { Title } </h2>
            <p> { Description } </p>    
        </section>
    
    </article>
)

CardLastProjects.propTypes = {
    Title: PropTypes.string,
    Description: PropTypes.string,
    LinkProject: PropTypes.string,
    LinkImage: PropTypes.string
}
CardLastProjects.defaultProps = {
    Title: "Name Project",
    Description: "Description Project",
    LinkProject: "https://linkedin.com/in/eliud-cesar",
    LinkImage: "https://cdn.pixabay.com/photo/2021/02/26/16/29/error-404-6052476_960_720.png"
}

export default CardLastProjects;
